import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  english: boolean = false;

  getLanguage(): Observable<boolean> {
    return of(this.english)
  }

  setFrench()  {
    this.english = false;
  }

  setEnglish () {
    this.english = true;
  }

  constructor() {
  }
}
